import axios from "axios";

const landingPage = import.meta.env.VITE_LANDING_PAGE;

const apiClient = axios.create({
  baseURL:
    landingPage === "vvv" || landingPage === "creatorshield"
      ? "https://app-cs-dashboardapp-prod.azurewebsites.net/api/"
      : "https://enfinicore-dev-be-fvdgftefefe3atcr.eastus2-01.azurewebsites.net/api/",
      // : "https://enfinicore-staging-be-ctcdc0b7drb5evek.canadacentral-01.azurewebsites.net/api/",
      // : "https://enfinicore-staging-be-ctcdc0b7drb5evek.canadacentral-01.azurewebsites.net/api/",
  // landingPage === "vvv"
  //   ? "http://localhost:5000/api/"
  //   : "http://localhost:8000/api/",
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      console.error("API Error:", error.response.status, error.response.data);

      if (error.response.status === 429) {
        return Promise.reject(
          new Error("Too many requests. Please try again later.")
        );
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
